import { v4 as uuidv4 } from 'uuid'
import { ERROR_MESSAGES } from 'src/Utils/globalEnums'
import { RequirementDraft, SectionDraft } from './FrameworkSectionsEditor.types'

export const createEmptyRequirementDraft = (): RequirementDraft => ({
  tempId: uuidv4(),
  name: '',
  description: '',
  controlIds: [],
})

export const createEmptySectionDraft = (): SectionDraft => ({
  tempId: uuidv4(),
  name: '',
  description: '',
  requirements: [],
})

export const getEmptyNameErrors = (
  sections: SectionDraft[],
): {
  sectionNames: Record<string, string>
  requirementNames: Record<string, string>
} => {
  const sectionNames: Record<string, string> = {}
  const requirementNames: Record<string, string> = {}
  for (const section of sections) {
    if (!section.name.trim()) {
      sectionNames[section.tempId] = ERROR_MESSAGES.EMPTY
    }
    for (const requirement of section.requirements) {
      if (!requirement.name.trim()) {
        requirementNames[requirement.tempId] = ERROR_MESSAGES.EMPTY
      }
    }
  }
  return { sectionNames, requirementNames }
}
